import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React from 'react';
import * as _ from "../../../util/lodash";
import { createComponent, PropTypes } from "../../../wayin-react";
import Panel from "./../panel";
import Layout from "./../../core/layout";
import Validators from "../../../validators";
import ValidatableAssetUploader from "./../../core/asset-uploader/validatable-asset-uploader";
import ColorPicker from "./../../core/color-picker";
import MediaSettings from "../media-settings";
import assetRefService from "../../../util/asset";
import { assetServices, uploadAssetTypes, videoServices, widths, positions, bgImageSizings, bgImageRepeats, bgImageScrollings } from "../../../enums";
/**
 * create a validatable asset uploader, so we can define our 'is required' and 'is valid media' rules.
 */

var MediaUrlUploader = ValidatableAssetUploader.Media({
  isRequired: function isRequired(value, validationContext) {
    return validationContext.isRequired === true ? Validators.isRequired(validationContext.requiredMessage)(assetRefService.deserialize(value).location) : true;
  },
  isValidMedia: function isValidMedia(value, validationContext) {
    //in case of a 'Media' uploader, we can get an image asset ref OR a video asset ref, so it's important to only trigger the video url validation when having a 'video url'
    var assetRefObj = assetRefService.deserialize(value);

    if (assetRefObj.service === assetServices.WEB_URL && assetRefObj.assetType === uploadAssetTypes.VIDEO_URL) {
      return Validators.isVideoUrl(validationContext.acceptedVideoServices, validationContext.invalidVideoMessage)(assetRefObj.location);
    }

    return true;
  }
});
/**
 * Component for editing a 'background media'
 */

var BackgroundMedia = createComponent({
  displayName: 'BackgroundMedia',
  propTypes: {
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    heading: PropTypes.string,
    byline: PropTypes.string,
    colorLabel: PropTypes.string,
    imageLabel: PropTypes.string,
    sizingLabel: PropTypes.string,
    scrollingLabel: PropTypes.string,
    repeatLabel: PropTypes.string,
    hasBorder: PropTypes.bool,
    style: PropTypes.object,
    formId: PropTypes.string.isRequired,
    fieldId: PropTypes.string.isRequired,
    acceptedVideoServices: PropTypes.array,
    invalidVideoMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    requiredMessage: PropTypes.string,
    //other props to be passed to the asset uploaders.
    libraryRef: PropTypes.string,
    containerRef: PropTypes.string,
    imageIdentifier: PropTypes.string.isRequired,
    imageUploadLabel: PropTypes.string,
    imageSelectLabel: PropTypes.string,
    uploadUrl: PropTypes.string,
    videoPlaceholderText: PropTypes.string,
    showVideoUrlButton: PropTypes.bool,
    sizingDefaultValue: PropTypes.string,
    repeatDefaultValue: PropTypes.string,
    scrollingDefaultValue: PropTypes.string
  },
  defaultProps: {
    id: '',
    value: '',
    heading: '',
    byline: '',
    colorLabel: 'Background color',
    imageLabel: 'Background',
    uploadUrl: '',
    sizingLabel: 'Background display sizing',
    scrollingLabel: 'Background scroll',
    repeatLabel: 'Background repeat',
    hasBorder: false,
    style: null,
    //to be used with the asset uploaders - select from library screen
    libraryRef: '',
    containerRef: '',
    imageIdentifier: '',
    imageUploadLabel: null,
    imageSelectLabel: null,
    acceptedVideoServices: [videoServices.YOUTUBE],
    invalidVideoMessage: undefined,
    isRequired: false,
    requiredMessage: undefined,
    videoPlaceholderText: '',
    showVideoUrlButton: true,
    sizingDefaultValue: bgImageSizings.COVER,
    repeatDefaultValue: bgImageRepeats.NO_REPEAT,
    scrollingDefaultValue: bgImageScrollings.SCROLL
  },
  handlers: {
    handleUrlChange: function handleUrlChange(p) {
      return function (ev, _ref) {
        var value = _ref.value;
        var assetRefObj = assetRefService.deserialize(value),
            currentAssetRefObj = assetRefService.deserialize(p.value);
        /**
        * if the image was just removed, but we had a color previously, we need to set the service type to background and keep the color
        * the media uploader component removes ALL settings, so we need to get back the color from the prev asset obj ref
        */

        if (!assetRefObj.location && currentAssetRefObj.settings.color) {
          assetRefObj.service = 'background';
          assetRefObj.settings.color = currentAssetRefObj.settings.color;
        }

        p.onChange(ev, {
          id: p.id,
          value: assetRefService.serialize(assetRefObj)
        });
      };
    },
    handleColorChange: function handleColorChange(p) {
      return function (ev, _ref2) {
        var value = _ref2.value;
        var assetRefObj = assetRefService.deserialize(p.value);
        assetRefObj.settings.color = value;
        /**
        * even without an image, we can have a color, just need to reset the service type to background
        */

        if (!assetRefObj.location && assetRefObj.settings.color) {
          assetRefObj.service = 'background';
        }

        p.onChange(ev, {
          id: p.id,
          value: assetRefService.serialize(assetRefObj)
        });
      };
    },

    /**
     * gets the media settings and merges them into the asset ref settings
     */
    handleMediaChange: function handleMediaChange(p) {
      return function (ev, _ref3) {
        var value = _ref3.value;

        var mediaAssetRefObj = assetRefService.deserialize(value),
            //this contains media settings like: repeat/size/attachment
        mediaSettings = _.pick(mediaAssetRefObj.settings, ['repeat', 'size', 'attachment']),
            assetRefObj = assetRefService.deserialize(p.value);

        _Object$assign(assetRefObj.settings, mediaSettings);

        p.onChange(ev, {
          id: p.id,
          value: assetRefService.serialize(assetRefObj)
        });
      };
    }
  },
  render: function render(p) {
    var handleUrlChange = p.handleUrlChange,
        handleColorChange = p.handleColorChange,
        handleMediaChange = p.handleMediaChange,
        acceptedVideoServices = p.acceptedVideoServices,
        isRequired = p.isRequired,
        invalidVideoMessage = p.invalidVideoMessage,
        requiredMessage = p.requiredMessage,
        videoPlaceholderText = p.videoPlaceholderText,
        showVideoUrlButton = p.showVideoUrlButton;
    var assetRefObj = assetRefService.deserialize(p.value);
    return /*#__PURE__*/React.createElement("div", {
      className: "ck background-media",
      style: p.style
    }, /*#__PURE__*/React.createElement(Panel, {
      hasBorder: p.hasBorder,
      header: p.heading,
      byline: p.byline,
      style: {
        padding: 0,
        margin: 0
      }
    }, /*#__PURE__*/React.createElement(Layout, {
      columns: widths.ONE
    }, /*#__PURE__*/React.createElement(ColorPicker, {
      value: assetRefObj.settings.color,
      label: p.colorLabel,
      onChange: handleColorChange,
      position: positions.BOTTOM,
      showClearIcon: true,
      isCompact: false
    }), /*#__PURE__*/React.createElement(MediaUrlUploader, {
      value: p.value,
      onChange: handleUrlChange,
      label: p.imageLabel,
      uploadButtonText: p.imageUploadLabel,
      selectButtonText: p.imageSelectLabel,
      stateIdentifier: p.imageIdentifier,
      libraryRef: p.libraryRef,
      containerRef: p.containerRef,
      uploadUrl: p.uploadUrl,
      hasBorder: false,
      isFluid: true,
      formId: p.formId,
      fieldId: p.fieldId,
      validateOn: "onChange",
      validationContext: {
        acceptedVideoServices: acceptedVideoServices,
        isRequired: isRequired,
        invalidVideoMessage: invalidVideoMessage,
        requiredMessage: requiredMessage
      },
      videoPlaceholderText: videoPlaceholderText,
      showVideoUrlButton: showVideoUrlButton
    }), /*#__PURE__*/React.createElement(MediaSettings, {
      assetRef: p.value,
      onChange: handleMediaChange,
      id: p.id
    }, /*#__PURE__*/React.createElement(MediaSettings.SizeMenu, {
      defaultValue: p.sizingDefaultValue,
      label: p.sizingLabel
    }), /*#__PURE__*/React.createElement(MediaSettings.ScrollMenu, {
      defaultValue: p.scrollingDefaultValue,
      label: p.scrollingLabel
    }), /*#__PURE__*/React.createElement(MediaSettings.RepeatMenu, {
      defaultValue: p.repeatDefaultValue,
      label: p.repeatLabel
    })))));
  }
});
export default BackgroundMedia;
//# sourceMappingURL=index.js.map